import { TbFileDescription } from "react-icons/tb"
import { classbtColunasVermelho, classDtCriarAtt, classInput, classLabel, classUserCriarAtt, ContatoCliente } from "../../Utils/Types"
import React, { useEffect } from "react"
import moment from "moment"

type Props = {
    visible: boolean
    listaAtributos?: any
    //dt_cadastro?: string
   // name_user_insert?: string
    //dt_last_updat?: string
    //name_user_last_update?: string
    closeModalEvent?: () => void
    
}

export const ModalAuditoria = React.memo(({ visible, listaAtributos, closeModalEvent}: Props) => {

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_auditoria')
            let modalContent = document.getElementById('modal_content_auditoria')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_auditoria')
            let modalContent = document.getElementById('modal_content_auditoria')

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]');
                    modalContent.classList.remove('mt-24');
                }
            }
        }

    }, [visible])

    const handleModalClose = () => {

        let modal = document.getElementById('modal_auditoria')

        if (modal) {
            modal.style.visibility = 'hidden'
            let modalContent = document.getElementById('modal_content_auditoria')

            if (modalContent) {
                modalContent.classList.add('mt-[-400px]')
                modalContent.classList.remove('mt-24')
            }
        }

    }

    return (

        <div id="modal_auditoria" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_auditoria" className={`relative flex flex-col w-[90%] sm:w-[60%] xl:w-[40%] h-[300px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>


                {/* Header */}
                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center pl-4`}>

                    <div className={`flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <TbFileDescription className={`w-5 h-5 text-slate-700 dark:text-slate-100`}></TbFileDescription>
                    </div>

                    <span className={`ml-2 text-lg text-slate-700 dark:text-slate-100`}>Auditoria</span>

                </div>
                {/* Header */}


                {/* Body */}

                <div className={`absolute top-[70px] bottom-[60px] w-full p-4 flex flex-row`}>

                
                    <div className={`w-full grid grid-cols-12`}>

                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                            <label htmlFor="userCriacao" className={`${classUserCriarAtt}`}>Criador</label>
                            <span id="userCriacao" className={`${classDtCriarAtt}`}>{listaAtributos?.name_user_insert || ''}</span> 
                        </div>

                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                            <label htmlFor="dtCriacao" className={`${classUserCriarAtt}`}>Data de Criação</label>
                            <span id="dtCriacao" className={`${classDtCriarAtt}`}>{listaAtributos?.dt_cadastro ? moment(listaAtributos?.dt_cadastro).format("DD/MM/YYYY HH:mm") : ''}</span>
                        </div>

                    </div>

                    <div className={`w-full grid grid-cols-12`}>

                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                            <label htmlFor="userAtt" className={`${classUserCriarAtt}`}>Atualizador</label>
                            <span id="userAtt" className={`${classDtCriarAtt}`}>{listaAtributos?.name_user_last_update }</span> 
                        </div>

                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                            <label htmlFor="dtAtt" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                            <span id="dtAtt" className={`${classDtCriarAtt}`}>{listaAtributos?.dt_last_update ? moment(listaAtributos?.dt_last_update).format("DD/MM/YYYY HH:mm") : ''}</span> 
                        </div>

                    </div>

                </div>
                {/* Body */}


                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 px-3 rounded-b-lg `}>
                    <button
                        onClick={closeModalEvent}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        VOLTAR
                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>

    )



})